export default {
  thankYou: {
    title: "Köszönjük!",
    message: "Az űrlapot sikeresen elküldtük. Köszönjük érdeklődését szolgáltatásaink iránt, és a lehető leghamarabb feldolgozzuk kérését.",
    contactInfo: "Ha bármilyen kérdése van, forduljon hozzánk bizalommal a +36 70 585 9959 telefonszámon vagy az info@atgroup.hu e-mail címen.",
    homeButton: "VISSZA A FŐOLDALRA",
    contactButton: "KAPCSOLAT"
  },
  common: { // Added common section
    back: "Vissza"
  },
  cookieConsent: {
    title: "Cookie-k használata",
    message: "Weboldalunk cookie-kat használ a felhasználói élmény javítása érdekében. A weboldal használatával elfogadja a cookie-k használatát.",
    accept: "Elfogadom",
    decline: "Elutasítom",
    learnMore: "További információ"
  },
  nav: {
    home: "FŐOLDAL",
    about: "RÓLUNK",
    contact: "KAPCSOLAT",
    parkingAndWash: "PARKOLÁS & AUTÓMOSÓ",
    serviceAndTire: "SZERVIZ & GUMISZERVIZ",
    services: "ÁRAK",
    faq: "GYIK"
  },
  faq: {
    title: "Gyakran Ismételt Kérdések",
    subtitle: "Gyors válaszok parkolásról, szervizről és foglalásról.",
    explore: "Összes kérdés megtekintése",
    contactCta: "Személyes segítségre van szüksége?",
    contactButton: "Lépjen kapcsolatba velünk"
  },
  hero: {
    welcome: "Üdvözöljük az A&T Groupnál!",
    subtitle: "Ahol az autója minden igényére egy helyen kínálunk megoldást!",
    cta: "FOGLALJON MOST"
  },
  booking: {
    title: "FOGLALJON HELYET",
    button: "Reptéri Parkolás Foglalása",
    // --- New Booking Page Content ---
    content: {
      sectionTitle: "Reptéri Parkolás Foglalás Részletei",
      paragraph1: "Üdvözöljük online foglalási rendszerünkben. Kérjük, adja meg az alábbi szükséges információkat, hogy lefoglalhassa parkolóhelyét az A&T Group reptér melletti létesítményében.",
      paragraph2: "Telephelyünk csak percekre található a repülőtértől, biztonságos és kényelmes parkolási megoldást kínálva utazásához.",
      paragraph3: "Kérésének elküldése után visszaigazoló e-mailt fog kapni a foglalás minden részletével, beleértve az útvonaltervet és a bejelentkezési eljárásokat.",
      note: "Ha bármilyen különleges kérése van vagy segítségre van szüksége, kérjük, lépjen kapcsolatba velünk közvetlenül."
    }
    // --- End New Content ---
  },
  services: {
    title: "Kérjük, válasszon egy szolgáltatást az alábbiak közül",
    parking: {
      title: "24/7 REPÜLŐTÉRI PARKOLÁS",
      description: "0-24 őrzött reptéri parkolás ingyenes transzferrel, pár percre a repülőtértől. Bekerített telephely helyszíni személyzettel."
    },
    washing: {
      title: "AUTÓMOSÓ",
      description: "Ajándékozza meg járművét egy fürdőnappal professzionális autómosó szolgáltatásainkkal, amelyek célja, hogy autója csillogóan tisztán és fiatalon maradjon."
    },
    tire: {
      title: "GUMISZERVIZ", // Fixed typo from previous hu.js 'GUMISZERIVZ'
      description: "Szakértő technikusaink készen állnak az abroncsokkal kapcsolatos bármilyen probléma azonnali megoldására, hogy biztonságosan visszatérhessen az útra."
    },
    service: {
      title: "AUTÓSZERVIZ",
      description: "A rutinellenőrzéstől a komplex javításokig szakképzett szerelőink fel vannak szerelve az összes karbantartás elvégzésére."
    }
  },
  testimonials: {
    title: "Ügyfeleink Véleménye",
    viewAll: "Összes vélemény megtekintése"
  },
  cta: {
    discover: "Fedezze fel versenyképes árainkat – nézze meg most!",
    button: "Árlista Megtekintése"
  },
  footer: {
    visit: "LÁTOGASSON MEG MINKET",
    address: "Vecsés Széchényi utca 62 mellett, Hrsz 0182/55, 2220",
    phone: "Telefon",
    phoneNumber: "+36 70 585 9959",
    email: "Email",
    emailAddress: "info@atgroup.hu",
    links: "Hivatkozások",
    copyright: "© 2025 atgroup.hu. Minden jog fenntartva."
  }
};